/// <reference path="../../types.d.ts" />
import React, { useState, SyntheticEvent } from 'react';
import { Button } from '../../components/button/button';
import { ButtonSize } from '../../core/enums';
import { ButtonVariant } from '../../core/enums';
import { Checkbox } from '@chakra-ui/react';
import { Flex } from '@chakra-ui/react';
import { Select } from '../../components/select/select';

import './context-choice-form.scss';
import { useHistory } from 'react-router';

const ContextChoiceForm: React.FC<CMx.ContextChoiceProps> = (
  props: CMx.ContextChoiceProps
) => {
  const { contexts, handleOrganizationChoice, user } = props;

  const [selectedOrg, selectOrg] = useState<number | null>(null);
  const [selectedOrgName, selectOrgName] = useState<string>('');
  const [isDefault, setIsDefault] = useState<boolean>(false);

  const history = useHistory();

  const handleDefaultCheck = (e: SyntheticEvent<HTMLInputElement>) => {
    setIsDefault(!isDefault);
  };

  const handleSave = (e?: React.MouseEvent<HTMLElement>) => {
    if (e) {
      e.preventDefault();
      if (selectedOrg !== null) {
        handleOrganizationChoice({
          organizationId: selectedOrg,
          setDefault: isDefault,
          userId: user.id || undefined
        });
      }
    }
  };

  const handleOrgSelection = (event: React.MouseEvent<HTMLElement>) => {
    const target = event.target as HTMLInputElement;
    const { value, textContent } = target;
    selectOrg(+value);
    selectOrgName(textContent ?? '');
  };

  const handleBackSelection = (e?: React.MouseEvent<HTMLElement>) => {
    if (e) {
      e.preventDefault();
      history.goBack();
    }
  };

  const convertContexts = (items: CMxAPI.OrganizationContext[]) =>
    items.map((item: CMxAPI.OrganizationContext) => ({
      value: item.organizationId,
      label:
        item.displayName && item.displayName !== ''
          ? item.displayName
          : item.shortDisplayName && item.shortDisplayName !== ''
          ? item.shortDisplayName
          : item.organizationCode
    }));

  return (
    <div className="context-choice-form form-group">
      <div className="form-row">
        <label className="form-label">Where are you working today?</label>
        <Select
          placeholder="Choose your organization"
          items={convertContexts(contexts)}
          value={selectedOrgName}
          onChange={handleOrgSelection}
          dataTestId="selectOrg"
        />
      </div>
      <div className="checkbox-container">
        <Checkbox onChange={handleDefaultCheck} />
        <i className="form-icon"></i> Remember my choice
      </div>
      <Flex className="form-buttons">
        <Button
          size={ButtonSize.MD}
          label="Back"
          variant={ButtonVariant.LINKS}
          dataTestId="back"
          onClick={handleBackSelection}
        />
        <Button
          size={ButtonSize.MD}
          label={'Continue'}
          variant={ButtonVariant.PRIMARY}
          disabled={selectedOrg === null}
          name="Continue"
          dataTestId="continue"
          onClick={handleSave}
        />
      </Flex>
    </div>
  );
};

export default ContextChoiceForm;
